import { useAppSelector } from '@/hooks/redux/redux';
import { Select } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ComboboxItem, ComboboxLikeRenderOptionInput } from '@mantine/core/lib/components/Combobox';
import classes from './language-select.module.css';

interface IProps {
  value: string;
  label?: string;
}
const src = (lng: string) => `https://flagcdn.com/${lng === 'en' ? 'us' : lng}.svg`;

const RenderLanguageOption = (item: ComboboxLikeRenderOptionInput<ComboboxItem>) => {
  return (
    <div className={classes.option}>
      <img width={18} height={18} src={src(item.option.value)} alt={item.option.value} />
      <div>{item.option.label}</div>
    </div>
  );
};

export const LanguageSelect = ({ value, ...rest }: IProps) => {
  const { t } = useTranslation();

  const { Languages } = useAppSelector((state) => state.commonSettings.LanguageSettings);

  const languageData = useMemo(() => {
    return Object.values(Languages)?.map((language) => ({
      label: language.Name,
      value: language.Id
    }));
  }, [Languages]);

  const currentLang = src(value);

  return (
    <Select
      w="100%"
      miw={352}
      maw={380}
      styles={{
        label: { color: '#667085', fontSize: 12 }
      }}
      radius="md"
      leftSection={
        value ? <img width={18} height={18} src={currentLang} alt={currentLang} /> : null
      }
      renderOption={RenderLanguageOption}
      label={t('profile.language')}
      placeholder={t('profile.selectLanguage')}
      data={languageData}
      value={value}
      mb={25}
      rightSection={<IconChevronDown stroke={1.5} />}
      searchable
      allowDeselect={false}
      {...rest}
    />
  );
};
